import { FC, useEffect, useState } from 'react';
import { PrequelContext, defaultPrequelState } from './context';
import { fetchPrequelAuthToken } from '../../utils/authToken';

interface PrequelContextProviderProps {
  children: React.ReactNode;
}

/**
 * PrequelContextProvider component to dynamically load @prequel/react and provide auth token function.
 */
export const PrequelContextProvider: FC<PrequelContextProviderProps> = ({ children }) => {
  const [prequelInstance, setPrequelInstance] = useState<typeof import('@prequel/react')>(
    defaultPrequelState.prequel,
  );

  useEffect(() => {
    // Dynamically import the @prequel/react library.
    import('@prequel/react')
      .then((prequel) => {
        setPrequelInstance(prequel);
      })
      .catch((error) => {
        console.error('Failed to load @prequel/react:', error);
      });
  }, []);

  return (
    <PrequelContext.Provider
      value={{
        prequel: prequelInstance,
        isPrequelReady: Object.keys(prequelInstance).length > 0,
        fetchPrequelAuthToken,
      }}
    >
      {children}
    </PrequelContext.Provider>
  );
};
